import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import moment from "moment";
import _ from "lodash";
import { env } from "../../env";
import { Lotto6Context } from "../../store/lotto6/Lotto6Context";
import {
    clearCartLotto6,
    deleteLotto6Betting,
    fetchLotto6DrawingResult,
    fetchLotto6ListBetting,
    fetchLotto6RecentBetReport,
    fetchLotto6RecentBetReportCache,
    fetchLotto6RecentDraw,
    fetchStatistic6,
    lotto6AddBetting,
    lotto6ConfirmBettingNow,
    playCountDownAudio,
    playGoodLuckAudio,
    setBetStatusLotto6,
    setIsAddToCart,
    setIsAutoPrint,
    setRenderResultStatus,
    setResultTotalNumberKeno
} from "../../store/rootAction";
import { fetchUserBalance, fetchUserBalanceValidate } from "../../store/user/action";
import { playAudio as playAudioUtil } from "../../store/audio/action";
import { getMute6, toggleMute6 } from "../../utils/cached";
import { fetchLottoConfig } from "../../store/config/action";
import {
    BetCodes6,
    clientAp,
    getOECode,
    isDisabledODEO,
    isOE,
    jackpotNum,
    pfType999
} from "../../constants/general";
import { SUBSCRIPTION_LOTTO6 } from "../../constants/lotto6";
import swal from "sweetalert";
import { getResult } from "../../utils/general";
import winSound from "../../assets/audios/lotto5_win.mp3";
import { sessionStore } from "../../utils/storage";

class MainDrawingWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showBetting: false,
            betCode: "",
            betAmount: 0,
            betGameType: "",
            betGameOdds: "",
            betGameRange: "",
            betGameTime: "",
            resultItem: null,
            resultItemRandom: null,
            indexResultItem: 0,
            totalResult: null,
            allNumbers: [],
            classNameNumberDraw: "lotto6-hide-number-draw",
            classNameLogoRender: "lotto6-hide-logo-render",
            classCountDown: "lotto6-total-result-render-count ",
            winUnderOver: "",
            winOddEven: "",
            winRange: "",
            winRangeLine: "",
            winRangeLineOne: "",
            betMessage: "",
            isShowRecentBet: false,
            imageRotate: "",
            imageBalanceRotate: "",
            imageResultRotate: "",
            isShowValidateBalance: false,
            messageValidateBalance: null,
            isStoppedJackpot: true,
            showJackpotValue: false,
            isEnableBetNow: true,
            jackpot: 0
        };
    }

    componentDidMount() {
        this.props.fetchLottoConfig();
        this.subscription();
        this.props.fetchUserBalance();
        this.props.fetchLotto6ListBetting({ isClear: true });
        this.checkDrawingResult();
        this.props.fetchLotto6RecentBetReport();
        const stSize = this.props.stSize;
        this.props.fetchStatistic6(stSize);
        this.getRecentDraw();
        this.listenLocalStorage();
    }

    componentWillUnmount() {
        this.drawingTime && clearTimeout(this.drawingTime);
        this.random && clearInterval(this.random);
        this.startDrawing && clearTimeout(this.startDrawing);
        this.jackpotInv && clearInterval(this.jackpotInv);
        this.showLoading && clearTimeout(this.showLoading);
    }

    playAudio = (src) => {
        const { audio, isIframe, appClass } = this.props;
        if (isIframe && !appClass) {
            if (audio && this.state.isMute === "OFF") playAudioUtil(src);
        } else {
            if (audio && !audio.isMute) playAudioUtil(src);
        }
    };

    onCloseValidateBalance = () => {
        this.setState({
            isShowValidateBalance: false,
            messageValidateBalance: null
        });
    }

    drawReleaseResult = (timeout) => {
        let indexResultItem = this.state.indexResultItem + 1
        if (indexResultItem < 7) {
            this.playAudio("https://bct168-s3.s3-ap-southeast-1.amazonaws.com/sound/drawing/drawing-3-new.mp3")
        }
        if (indexResultItem === 7) {
            this.setWinLose(indexResultItem);
        } else if (indexResultItem === 8) {
            // this.preSetnewResult();
        } else {
            let resultItem = 1
            if (this.random) {
                clearInterval(this.random);
            }
            this.random = setInterval(() => {
                if (resultItem === 37) {
                    resultItem = 1
                }
                this.setState({ resultItem: resultItem++ })
            }, 10)
            this.startDrawing && clearTimeout(this.startDrawing);
            this.startDrawing = setTimeout(() => {
                if (this.random) {
                    clearInterval(this.random)
                }
                let { resultItem, totalResult, allNumbersDrawing } = getResult(indexResultItem, this.props.oldResult);
                this.setState({
                    resultItem: resultItem,
                    indexResultItem: indexResultItem,
                    totalResult: totalResult,
                    allNumbers: allNumbersDrawing,
                    classNameNumberDraw: "lotto6-show-number-draw"
                }, () => clearTimeout(this.startDrawing));
            }, timeout)
        }
    }

    showResultRender = () => {
        this.random && clearInterval(this.random);

        this.jackpotInv && clearInterval(this.jackpotInv);
        let num = 0;
        if (this.props.oldResult?.jackpot > 1) {
            this.jackpotInv = setInterval(() => {
                if (num >= 6) num = 0;
                num += 1;
                this.setState({
                    jackpot: num,
                });
            }, 800);
        } else {
            this.setState({
                jackpot: 0,
            });
        }

        this.setState({
            classNameNumberDraw: "lotto6-show-number-draw",
            classNameLogoRender: "lotto6-hide-logo-render"
        });
        this.drawReleaseResult(3000);
        if (this.drawingTime) {
            clearInterval(this.drawingTime)
        }
        this.drawingTime = setInterval(() => {
            this.drawReleaseResult(2500);
        }, 3500)
    }

    setWinLose = (indexResultItem) => {
        let { oldResult } = this.props;
        let jp = _.toUpper(oldResult?.rangeCode) === oldResult.jackpotType ? jackpotNum[oldResult.jackpotType] : 0

        this.jackpotInv && clearInterval(this.jackpotInv);
        jp > 0 && this.playAudio(winSound);

        let src = `https://bct168-s3.s3-ap-southeast-1.amazonaws.com/sound/result/result-${BetCodes6[oldResult?.rangeCode]}-${BetCodes6[oldResult?.underOverCode]}.mp3`;
        this.setState({
            winUnderOver: oldResult?.underOverCode,
            winOddEven: oldResult?.oddEvenCode,
            winRange: oldResult?.rangeCode,
            winRangeLine: oldResult?.rangeLineCode,
            winRangeLineOne: oldResult?.rangeLineOneCode,
            resultItem: null,
            indexResultItem: indexResultItem,
            totalResult: null,
            jackpot: jp,
            classNameNumberDraw: "lotto6-hide-number-draw",
            classNameLogoRender: "lotto6-show-logo-render",
            classCountDown: "lotto6-total-result-render-count "
        })
        this.playAudio(src)
    }

    preSetnewResult = () => {
        if (this.drawingTime) {
            clearInterval(this.drawingTime);
        }
        this.setState({
            winUnderOver: "",
            winOddEven: "",
            winRange: "",
            winRangeLine: "",
            winRangeLineOne: "",
            resultItem: null,
            indexResultItem: 0,
            totalResult: null,
            showJackpotValue: false,
            classNameNumberDraw: "lotto6-hide-number-draw",
            classNameLogoRender: "lotto6-show-logo-render",
            classCountDown: "lotto6-total-result-render-count "
        })
        this.props.setRenderResultStatus({ isStopRender: true });
        this.setnewResult();

    }
    setnewResult = () => {
        this.props.fetchLotto6DrawingResult()
            .then(() => {
                const { countDownTimer } = this.props;
                if (countDownTimer > 0) {
                    this.setState({
                        classNameNumberDraw: "lotto6-hide-number-draw",
                        classNameLogoRender: "lotto6-show-logo-render",
                        classCountDown: "lotto6-total-result-render-count"
                    })
                    this.countingSecond(countDownTimer);
                }
            })
    }


    refreshData = () => {
        this.preSetnewResult();
        this.refresh = setTimeout(() => {
            this.playAudio("https://bct168-s3.s3-ap-southeast-1.amazonaws.com/sound/thank/thank.mp3");
            clearTimeout(this.refresh);
        }, 1000);
        this.props.fetchLotto6RecentBetReportCache();
        this.props.fetchUserBalance()
        const stSize = this.props.stSize;
        this.props.fetchStatistic6(stSize);
        this.getRecentDraw();

    }

    getRecentDraw = () => {
        this.props.fetchLotto6RecentDraw().then(() => {
            if (this.props.isStopRender) {
                const details = this.props.lastResult.details
                this.setState({ allNumbers: details })
            }
        });
    }

    subscription = () => {
        clientAp.subscribe({
            query: SUBSCRIPTION_LOTTO6,
        }).subscribe({
            next: (event) => {
                if (event.data && event.data.v_lotto6_drawing) {
                    let currentDraw = event.data.v_lotto6_drawing[0] || {};
                    this.onDrawStatusChange(currentDraw);
                }
            },
            error: (err) => {
                console.error("err", err);
            }
        });
    }

    listenLocalStorage = () => {
        window.onstorage = () => {
            let mute = getMute6();
            if (mute !== this.state.isMute) {
                this.setState({ isMute: mute });
            }
        }
    }

    toggleMute = () => {
        this.setState((preState) => ({
            isMute: preState.isMute === "OFF" ? "ON" : "OFF"
        }), () => toggleMute6(this.state.isMute));
    }

    onDrawStatusChange = (currentDraw) => {
        if (currentDraw.status !== this.state.status) {
            if (this.state.status && currentDraw.status === "OPEN") {
                this.refreshData();
            }
            this.setState({ status: currentDraw.status });
            if (currentDraw.status === "RELEASE") this.getResultDrawing(true);
            this.verifyCurrentDraw(currentDraw.drawCode);
        }
    }

    verifyCurrentDraw = currentDrawCode => {
        let betList = sessionStore.get("betting_lotto6", []);
        if (betList.length) {
            let firstItem = betList[0];
            if (firstItem.drawCode !== currentDrawCode) {
                this.props.clearCart();
            }
        }

    }

    countingSecond = (count) => {
        if (this.props.isStopRender) {
            if (this.props.countDownTimer < 0) {
                this.props.setRenderResultStatus({ isStopRender: true })
            } else {
                if (count >= this.props.closeBet) {
                    this.setState({ classCountDown: "lotto6-total-result-render-count" })
                } else if (count <= this.props.closeBet && count > 0) {
                    this.props.setBetStatus({ isStopBet: true });
                    this.props.playCountDownAudio(count - 1, this.state.isMute);
                    this.setState({ classCountDown: "lotto6-total-result-render-count-warning" })
                } else if (count === 0) {
                    this.props.playGoodLuckAduio(this.state.isMute);
                    this.setState({ classCountDown: "lotto6-total-result-render-count-total" })
                    this.props.clearCart();
                    this.props.setRenderResultStatus({ isStopRender: false })
                    this.getResultDrawing(true);
                    this.props.fetchUserBalance();

                }
            }
        }
    }

    checkDrawingResult = () => {
        this.props.fetchLotto6DrawingResult()
            .then(() => {
                if (this.props.indexNumber <= 6 && this.props.indexNumber >= 0 && this.props.indexNumber !== null) {
                    this.setState({ allNumbers: [] })
                    let totalResult = 0
                    let allNumbers = this.props.allNumbers.slice(0, this.props.indexNumber)
                    allNumbers.forEach(item => {
                        totalResult = totalResult + item
                    })
                    this.setState({
                        allNumbers: allNumbers,
                        indexResultItem: this.props.indexNumber,
                        totalResult: totalResult,
                        classNameNumberDraw: "lotto6-show-number-draw",
                        classNameLogoRender: "lotto6-hide-logo-render",
                        classCountDown: "lotto6-total-result-render-count-total"
                    })
                    this.showResultRender()
                } else if (this.props.countDownTimer > 0) {
                    this.setState({
                        classNameNumberDraw: "lotto6-hide-number-draw",
                        classNameLogoRender: "lotto6-show-logo-render",
                        classCountDown: "lotto6-total-result-render-count"
                    })

                } else if (this.props.countDownTimer <= 0) {
                    this.setState({
                        classNameNumberDraw: "lotto6-show-number-draw",
                        classNameLogoRender: "lotto6-hide-logo-render",
                        classCountDown: "lotto6-total-result-render-count-total"
                    })
                    this.props.setRenderResultStatus({ isStopRender: false });
                    return this.getReleaseNum();
                }
            }).catch(() => {
                this.setState({ allNumbers: [] });
            })
    }

    getResultDrawing = (value = false) => {
        this.props.fetchLotto6DrawingResult()
            .then(() =>
                this.getReleaseNum(value)).catch(() => {
                    this.setState({ allNumbers: [] });
                })
    }

    getReleaseNum = async () => {
        const { indexNumber, countDownTimer } = this.props;
        let count = Math.abs(countDownTimer);
        if (count <= 3) {
            this.showLoading = setTimeout(() => {
                this.drawResult(0);
                clearTimeout(this.showLoading)
            }, 3000);
            return false;
        } else if (indexNumber <= 20 && indexNumber >= 0) {
            this.drawResult(indexNumber);
        }

    }

    drawResult = (indexNumber) => {
        this.setState({ allNumbers: [] })
        let { allNumbersDrawing, totalResult } = getResult(indexNumber, this.props.oldResult);
        this.setState({
            allNumbers: allNumbersDrawing,
            indexResultItem: indexNumber,
            totalResult: totalResult,
            classNameNumberDraw: "lotto6-show-number-draw",
            classNameLogoRender: "lotto6-hide-logo-render"
        }, () => this.showResultRender());
    }

    onBetting = (item) => {
        if (!this.props.isStopBet) {
            this.props.fetchUserBalanceValidate()
                .then(() => {
                    this.setState({
                        showBetting: true,
                        betGameType: item.name,
                        betGameOdds: item.value,
                        betGameRange: item.resultRange,
                        betCode: item.code,
                        betGameTime: moment(new Date()).format('HH:mm:ss')
                    });
                }).catch(error => {
                    const { t } = this.props;
                    error && this.setState({
                        isShowValidateBalance: true,
                        messageValidateBalance: t("labels:common." + error.response.data.message)
                    });
                })
        }
    }

    onConfirmBetting = async (logs) => {
        const { user: { isAddToCart }, newResult } = this.props
        const {
            betCode,
            betAmount,
            betGameOdds
        } = this.state;
        const data = {
            drawCode: newResult.drawCode,
            betTypeCode: betCode,
            amount: betAmount,
            betLog: logs,
            rebateRate: betGameOdds
        }
        await this.props.lotto6AddBetting(data);
        !isAddToCart && this.submitBetNow();

        this.setState({
            showBetting: false,
            betAmount: 0,
            betGameType: "",
            betGameOdds: "",
            betCode: "",
            betGameRange: "",
            betGameTime: "",
            betMessage: ""
        })
    }

    onCancelBetting = () => {
        this.setState({
            showBetting: false,
            betAmount: 0,
            betGameType: '',
            betGameOdds: '',
            betMessage: "",
            betGameRange: "",
            betGameTime: "",
        })
    }

    showConfirmDelete = (id) => {
        this.setState({ showDeleteBetting: false, bettingId: null });
        this.props.deleteLotto6Betting({ id: id });
    }

    submitBetNow = () => {
        const { isEnableBetNow } = this.state;
        const { user } = this.props;
        isEnableBetNow && this.props.lotto6ConfirmBettingNow(() => this.setState({ isEnableBetNow: false }))
            .then(() => {
                this.setState({ isEnableBetNow: true })
                this.props.fetchLotto6RecentBetReport().then(() => user.isAutoPrint && document.getElementById("print-button").click());
                this.props.fetchUserBalance();
            }).catch((error) => {
                const { response } = error;
                this.setState({ isEnableBetNow: true });
                response && swal(response.data.message, { icon: "error", button: "បិទ" });
            })
    }

    clickAmountBetBtn = (amount) => {
        let betAmount = this.state.betAmount || 0;

        this.setState({
            betAmount: parseInt(betAmount) + amount,
        })
    }

    resetDefaultAmount = () => {
        this.setState({ betAmount: 0 })
    }

    changeBetAmount = (e) => {
        if (e.target.value >= 0 || !isNaN(e.target.value) || e.target.value === undefined) {
            this.setState({ betAmount: e.target.value })
        }
    }

    setBetMessage = (message = "") => {
        this.setState({ betMessage: message })
    }

    getTotalCartAmount = () => {
        return this.props.fetchLotto6ListBetting({ isClear: false }) || 0;
    }

    render() {
        const contextValue = {
            platform: env.PLATFORM_FOR,
            platformType: env.PLATFORM_TYPE,
            ...this.props,
            ...this.state,
            playAudio: this.playAudio,
            onCloseValidateBalance: this.onCloseValidateBalance,
            drawReleaseResult: this.drawReleaseResult,
            showResultRender: this.showResultRender,
            setWinLose: this.setWinLose,
            preSetnewResult: this.preSetnewResult,
            refreshData: this.refreshData,
            getRecentDraw: this.getRecentDraw,
            subscription: this.subscription,
            onDrawStatusChange: this.onDrawStatusChange,
            countingSecond: this.countingSecond,
            checkDrawingResult: this.checkDrawingResult,
            getResultDrawing: this.getResultDrawing,
            getReleaseNum: this.getReleaseNum,
            drawResult: this.drawResult,
            onBetting: this.onBetting,
            onConfirmBetting: this.onConfirmBetting,
            onCancelBetting: this.onCancelBetting,
            showConfirmDelete: this.showConfirmDelete,
            submitBetNow: this.submitBetNow,
            clickAmountBetBtn: this.clickAmountBetBtn,
            resetDefaultAmount: this.resetDefaultAmount,
            changeBetAmount: this.changeBetAmount,
            setBetMessage: this.setBetMessage,
            getTotalCartAmount: this.getTotalCartAmount,
            toggleMute: this.toggleMute,
            isDisabledODEO,
            getOECode,
            isOE,
            pfType999,
        };
        return (
            <Lotto6Context.Provider value={contextValue}>
                {this.props.children}
            </Lotto6Context.Provider>
        );
    }
}

const mapStateToProps = state => ({
    ...state.lotto6,
    ...state.lotto6.draw,
    user: state.user,
    audio: state.audio,
    config: state.config
});

const mapDispatchToProps = {
    setBetStatus: setBetStatusLotto6,
    setRenderResultStatus,
    setResultTotalNumber: setResultTotalNumberKeno,
    fetchLotto6RecentDraw,
    fetchLotto6DrawingResult,
    setIsAutoPrint,
    fetchStatistic6,
    lotto6AddBetting,
    deleteLotto6Betting,
    lotto6ConfirmBettingNow,
    fetchLotto6ListBetting,
    fetchLotto6RecentBetReport,
    fetchLotto6RecentBetReportCache,
    fetchUserBalance,
    fetchUserBalanceValidate,
    clearCart: clearCartLotto6,
    setIsAddToCart,
    playCountDownAudio,
    playGoodLuckAduio: playGoodLuckAudio,
    fetchLottoConfig
};

export default withTranslation()(connect(
    mapStateToProps,
    mapDispatchToProps
)(MainDrawingWrapper));
